import React, { useEffect, useState } from "react";
import "./subscriptionBodyForm.css";
import { Select, MenuItem } from "@mui/material";
import { toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import { handleToast, isValuePresent } from "../../utils";
import { createSubscription } from "../../services/api/subscription";

export default function RechargeBodyForm() {
  const [Name, setName] = useState("");
  const [Amount, setAmount] = useState("");
  const [state, setState] = useState("");
  const [finalPrice, setFinalPrice] = useState("");
  const [trialDays, setTrialDays] = useState("");
  const [trialCharge, setTrialCharge] = useState("");
  const [description, setDescription] = useState("");
  const [duration, setDuration] = useState("");
  const [timeframe, setTimeframe] = useState("");

  const [loader, setLoder] = useState(false);
  const [IsTrue, setIstrue] = useState(true);
  const isMobile = window.innerWidth <= 600;

  const requiredField = [
    Name,
    Amount,
    state,
    trialDays,
    trialCharge,
    description,
    duration,
    timeframe,
  ];

  const subscriptionobj = {
    name: Name,
    base_price: Amount,
    final_price: finalPrice,
    is_default: state,
    trial_days: trialDays,
    trial_charge: trialCharge,
    description: description,
    duration: duration,
    timeframe: timeframe,
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoder(true);

    try {
      createSubscription(JSON.stringify(subscriptionobj))
        .then((response) => {
          if (response.data.status === "success") {
            toast.success(response?.data?.message, {
              position: isMobile ? "top-left" : "top-center",
            });
            setLoder(false);
            remove();
          }
        })
        .catch((error) => {
          handleToast(error?.response?.data);
          setLoder(false);
        });
    } catch (error) {
      handleToast(error?.response?.data);
      setLoder(false);
    }
  };

  useEffect(() => {
    const isAllFilled = requiredField.some((field) => !isValuePresent(field));
    setIstrue(isAllFilled);
  }, [...requiredField]);

  const handlestate = (e) => {
    setIstrue(true);
    setState(e.target.value);
  };

  const remove = () => {
    setName("");
    setAmount("");
    setState("");
    setTrialDays("");
    setTrialCharge("");
    setDescription("");
    setDuration("");
    setTimeframe("");
    setFinalPrice("");
  };

  const handleNumber = (setter) => (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) setter(value);
  };

  return (
    <div className="language-top">
      {!loader ? (
        <form id="subscription-forms" onSubmit={handleSubmit}>
          <div className="subscription-input subbox">
            <label>
              <h4>
                Subscription Name <sup>*</sup>
              </h4>
            </label>
            <input
              type="text"
              placeholder="Enter subscription Name"
              value={Name}
              onChange={(e) =>
                setName(e.target.value.replace(/[^A-Za-z\s]/g, ""))
              }
              required
            />
          </div>

          <div className="subscription-code subbox">
            <div className="subcode">
              <label>
                <h4>
                  Subscription Amount <sup>*</sup>
                </h4>
              </label>
              <input
                type="text"
                placeholder="Enter subscription Amount"
                value={Amount}
                onChange={handleNumber(setAmount)}
                required
              />
            </div>

            <div className="subcode">
              <label>
                <h4>
                  Final Price <sup>*</sup>
                </h4>
              </label>
              <input
                type="text"
                placeholder="Enter Final Price"
                value={finalPrice}
                onChange={handleNumber(setFinalPrice)}
                required
              />
            </div>
          </div>

          <div className="subscription-code subbox">
            <div className="subcode">
              <label>
                <h4>
                  Trial Days <sup>*</sup>
                </h4>
              </label>
              <input
                type="text"
                placeholder="Enter Trial Days"
                value={trialDays}
                onChange={handleNumber(setTrialDays)}
                required
              />
            </div>

            <div className="subcode">
              <label>
                <h4>
                  Trial Charge <sup>*</sup>
                </h4>
              </label>
              <input
                type="text"
                placeholder="Enter Trial Charge"
                value={trialCharge}
                onChange={handleNumber(setTrialCharge)}
                required
              />
            </div>
          </div>

          <div className="subscription-code subbox">
            <div className="subcode">
              <label>
                <h4>
                  Timeframe <sup>*</sup>
                </h4>
              </label>
              <Select
                className="data-select"
                value={timeframe.toLowerCase()}
                style={{
                  background: "white",
                  width: "100%",
                  height: "48px",
                  border: "0.8px solid #1c1c1c54",
                  borderRadius: "10px",
                  color: "rgba(28, 28, 28, 0.56)",
                }}
                onChange={(e) => {
                  setTimeframe(e.target.value);
                  if (e.target.value === "daily") {
                    setDuration(7);
                  }
                }}
                displayEmpty
                required
              >
                <MenuItem value="" disabled>
                  Select Timeframe
                </MenuItem>
                <MenuItem value="daily">Daily</MenuItem>
                {/* <MenuItem value="weekly">Weekly</MenuItem> */}
                <MenuItem value="monthly">Monthly</MenuItem>
              </Select>
            </div>
            <div className="subcode">
              <label>
                <h4>
                  Duration <sup>*</sup>
                </h4>
              </label>
              <input
                type="text"
                disabled={!timeframe}
                style={{
                  outline:
                    timeframe === "daily" && duration < 7 && "1px solid red",
                }}
                placeholder="Enter Duration"
                value={duration}
                onChange={handleNumber(setDuration)}
                required
              />
              
              {(timeframe === "daily" && duration < 7 ) && 
              <p
               style={{
                color: 'red',
                fontWeight: 'bolder',
                fontSize: '0.8rem'
               }} 
              >
              Minimum daily timeframe is 7 days.
              </p>}
            </div>
          </div>
          <div className="subscription-code subbox">
            <div
              className="subcode"
              style={{
                width: "100%",
              }}
            >
              <label>
                <h4>
                  Is Default <sup>*</sup>
                </h4>
              </label>
              <Select
                className="data-select"
                value={state}
                style={{
                  background: "white",
                  width: "100%",
                  height: "48px",
                  border: "0.8px solid #1c1c1c54",
                  borderRadius: "10px",
                  color: "rgba(28, 28, 28, 0.56)",
                }}
                onChange={handlestate}
                displayEmpty
                required
              >
                <MenuItem value="" disabled>
                  Select Type
                </MenuItem>
                <MenuItem value={true}>True</MenuItem>
                <MenuItem value={false}>False</MenuItem>
              </Select>
            </div>
          </div>

          <div className="subscription-input subbox">
            <label>
              <h4>
                Description <sup>*</sup>
              </h4>
            </label>
            <input
              type="text"
              placeholder="Enter Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </div>

          <div className="submit">
            <button
              className="button-discard"
              onClick={remove}
              disabled={IsTrue}
              type="button"
              style={{
                outline: IsTrue
                  ? "none"
                  : " 1px solid var(--admin-page--color)",
                color: IsTrue ? "#1c1c1c6d" : "var(--admin-page--color)",
                background: IsTrue ? "rgba(63, 61, 61, 0.07)" : "#FFFFFF",
                cursor: IsTrue ? "not-allowed" : "pointer",
              }}
            >
              DISCARD CHANGES
            </button>
            <button
              className="button-create"
              type="submit"
              disabled={IsTrue}
              style={{
                outline: IsTrue
                  ? "none"
                  : " 1px solid var(--admin-page--color)",
                color: IsTrue ? "#1c1c1c6d" : "#ffffff",
                background: IsTrue
                  ? "rgba(63, 61, 61, 0.07)"
                  : " var(--admin-page--color)",
                cursor: IsTrue ? "not-allowed" : "pointer",
              }}
            >
              CREATE
            </button>
          </div>
        </form>
      ) : (
        <div className="loader">
          <CircularProgress style={{ color: "#F99234" }} />
        </div>
      )}
    </div>
  );
}
